// extracted by mini-css-extract-plugin
module.exports =  {"truncate":"Y5BjMVChJNhfRtr4X5Ya","trigger":"ToBuh19RSwVQxTFlMvO9"};